import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body1, Heading6 } from '@ui/Typography'

import { Button } from '@global/button/Button'

import { ExpandableModalMobile } from '../ExpandableModal/ExpandableModalMobile'
import { ModalTitle } from '../common/components/ModalTitle'
import { cloneButtonMobile, getSortedButtons } from '../common/helpers/button'
import { MessageModalProps } from './MessageModal'

import styles from './MessageModalMobile.module.scss'

export const MessageModalMobile: React.FC<MessageModalProps> = (props) => {
  const {
    title,
    description,
    icon,
    isLoading = false,
    children,
    onClose,
    renderFooter,
    headerless = false,
  } = props

  const { t } = useTranslation()

  return (
    <ExpandableModalMobile
      isLoading={isLoading}
      onClose={onClose}
      headerless={headerless}
      renderFooter={({ onClose }) =>
        renderFooter?.({ ...props, onClose }) ||
        getSortedButtons(props, [
          cloneButtonMobile(
            <Button appearance='primary' onClick={onClose} key='close'>
              {t('Close')}
            </Button>
          ),
        ])
      }
    >
      <div className={styles.wrapper}>
        <div className={styles.icon}>{icon}</div>

        <header className={styles.header}>
          {title && (
            <Heading6 align='center' medium>
              <ModalTitle title={title} />
            </Heading6>
          )}
          {description && (
            <div className={styles.description}>
              <Body1 isParagraph align='center'>
                {description}
              </Body1>
            </div>
          )}
        </header>

        <section className={styles.body}>{children}</section>
      </div>
    </ExpandableModalMobile>
  )
}
